import { render, staticRenderFns } from "./SiteDocumentApprovalStatus.vue?vue&type=template&id=48d0f0a6"
import script from "./SiteDocumentApprovalStatus.vue?vue&type=script&lang=js"
export * from "./SiteDocumentApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports